import styled from "styled-components";

export const StyledMenuTableIcon = styled.img`
  width: 100%;
  height: 44px;
  object-fit: contain;
  object-position: center;
`